import Button from 'components/button';
import ErrorMessage from 'components/error-message';

import styles from './styles.module.scss';

type BottomSheetErrorProps = { message: string; withButton: boolean; onClick?: () => void };

const BottomSheetError: React.FC<BottomSheetErrorProps> = (props) => {
  const { message, withButton, onClick } = props;

  return (
    <div className={styles.container}>
      <ErrorMessage message={message} />

      {withButton && <Button className={styles.button} label='Закрыть' onClick={onClick} />}
    </div>
  );
};

export default BottomSheetError;
